<div [class.container-component]="isManager">
  <div *ngIf="isManager">
    <h1 class="text-uppercase">Jornada variável</h1>

    <hr />

    <div class="container-information">
      <i class="mdi mdi-alert-circle-outline"></i>
      <p class="information">
        As alterações feitas aqui, somente terão efeito no dia seguinte.
      </p>
    </div>
  </div>

  <div class="form-item">
    <button
      type="button"
      class="btn btn-outline-primary text-uppercase btn-download-table d-flex justify-content-center align-items-center"
      (click)="downloadLastDocument()"
    >
      Baixar tabela
      <i class="mdi mdi-download-outline download-icon ms-2"></i>
    </button>
  </div>

  <div class="mt-4">
    <div class="row p-0 g-0">
      <h5 class="col-12 dayoff-upload-title">Anexar arquivo com as folgas</h5>
      <!-- <label class="text-default-label p-0 mt-3 d-block">Anexo:</label> -->
      <ng-container>
        <small class="p-0">
          Inclua em anexo um documento conforme nosso modelo, detalhando as
          folgas previstas.</small
        >
        <app-upload-file
          class="col-12 p-0"
          [selectedImage]="docImage"
          [permiteRemover]="true"
          [compactLayout]="!figmaDropzoneLayout"
          [figmaDropzoneLayout]="figmaDropzoneLayout"
          [uploadPromptPrefix]="effectiveUploadPrompt"
          [uploadButtonText]="effectiveUploadButtonText"
          (selectFileWithExtension)="selectedDocument($event)"
          [allowedExtensions]="['xlsx']"
          [AllowedAdvancedExtensions]="[
            'vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          ]"
        ></app-upload-file>
      </ng-container>

      <div
        class="dayoff-actions"
        *ngIf="isManager && useSaveCancelActions"
      >
        <button
          type="button"
          class="btn button-gray dayoff-actions__btn"
          (click)="onCancelImport()"
          [disabled]="!canCancelImport"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="btn btn-primary dayoff-actions__btn"
          (click)="onSaveImport()"
          [disabled]="!canSaveImport"
        >
          {{ savingImport ? "Salvando..." : "Salvar" }}
        </button>
      </div>

      <ng-template #readonly>
        <div class="col-sm-2 attach" *ngIf="attachedFile">
          <img
            class="img-file"
            alt="documento anexado"
            [src]="docImage"
            (click)="downloadFromUrl(attachedFile)"
          />
        </div>
        <span *ngIf="!attachedFile">Nenhum anexo adicionado</span>
      </ng-template>
    </div>
  </div>
</div>
